import * as momentTimezone from 'moment-timezone'
import {Moment} from 'moment'

export class Utilservice {
    static _moneyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    static formatCnpj(v) {
        let pad = new Array(15).join("0");
        v = (pad + String(v)).slice(-14);
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        return v;
    }

    static formatCep(v){
        let pad = new Array(9).join("0");
        v = (pad + String(v)).slice(-8);
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3');
        return v;
    }

    static formatDate(date){
        if(typeof date === 'number'){
          return momentTimezone.unix(date).format('DD/MM/YYYY')
        }

        return date ? date.substring(0, 10) : date;
    }

    static formatMoney(value){
        return this._moneyFormatter.format(value)
    }

    static formatQuantity(value){
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    static formatTimestampToString(timestamp:number | number[]){
        if(Array.isArray(timestamp)){
          let response = []

          timestamp.map(item => {
            const _timestamp = item*1000;
            response.push(
              momentTimezone(_timestamp).tz('America/Sao_Paulo').format('DD/MM/YYYY')
            )
          })

          return response
        }else{
          const _timestamp = timestamp*1000;
          return momentTimezone(_timestamp).tz('America/Sao_Paulo').format('DD/MM/YYYY')
        }
      }

    static convertTimestampArrayToMoment(timestamp:number[]): Moment[]{
      let response = []

      timestamp.map(item => {
        const _timestamp = item*1000;
        response.push(
          momentTimezone(_timestamp).tz('America/Sao_Paulo')
        )
      })

      return response
    }

    static dateIsInDulorenNextWeek(
      nextWeekOfDulorenTimestamp: number[],
      date: string,
      format = 'DD/MM/YYYY'
    ): boolean{
      const nextWeekOfDuloren = Utilservice.convertTimestampArrayToMoment(nextWeekOfDulorenTimestamp);
      const primeiroDiaProximaSemana = nextWeekOfDuloren[0];
      const ultimoDiaProximaSemana = nextWeekOfDuloren[nextWeekOfDuloren.length -1]

      const momentDate = momentTimezone(date, format)

      return momentDate.isSameOrAfter(primeiroDiaProximaSemana) && momentDate.isSameOrBefore(ultimoDiaProximaSemana)
    }

    static exportToFile(blobInput: any, nome: string, type='application/.ms-excel'){
      const blob: Blob = new Blob([blobInput], { type });
      const fileName: string = nome;
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }

    static exportToFilePdf(blobInput: any, nome: string, type='application/pdf'){
      const blob: Blob = new Blob([blobInput], { type });
      const fileName: string = nome;
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }

}
